var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"view-image-modal","hide-footer":"","hide-header":"","centered":"","dialog-class":"!p-0","body-class":"!p-0"}},[_c('b-img',{staticClass:"w-full",attrs:{"src":_vm.img,"alt":"image variant product"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }